"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useTemplates = _ref => {
  let {
    context,
    endpoint,
    queryParams,
    sort
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const extraPathItems = [];
  if (context) {
    extraPathItems.push(`filters=context=${context}`);
  }
  if (sort) {
    extraPathItems.push(`sort=${sort}`);
  }
  extraPathItems.push('max=500');
  const path = `${endpoint}?${extraPathItems.join('&')}`;
  const {
    data: templates
  } = (0, _reactQuery.useQuery)(['stripes-kint-components', 'useTemplates', 'templates', context ?? ''], () => ky(path).json(), queryParams);
  return templates || [];
};
var _default = exports.default = useTemplates;